export default __webpack_public_path__ + "static/media/Valinor.faf6cc83.png";